import { gql } from '@apollo/client';
import Fragments from './fragments';
export const ACTIVE_DOCUMENTS_QUERY = gql`
  query activeDocumentTypes {
    activeDocumentTypes {
      id
      code
      name
    }
  }
`;

export const OFFER_CANCELLED_CONDITION_QUERY = gql`
  query offerCancelledCondition {
    offerCancelledCondition {
      ...offerCancelled
    }
  }
  ${Fragments.offerCancelled}
  ${Fragments.conditions}
`;
